"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BadgeRectangle = void 0;
/** @jsx jsx */
var preact_1 = require("preact");
var react_1 = require("@emotion/react");
var classnames_1 = __importDefault(require("classnames"));
var mobx_react_1 = require("mobx-react");
var providers_1 = require("../../../providers");
var CSS = {
    BadgeRectangle: function (props) {
        return (0, react_1.css)({
            display: 'inline-block',
            boxSizing: 'border-box',
            padding: '0.3em 0.9em',
            background: props.color,
            color: props.colorText,
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            maxWidth: '100%',
        });
    },
};
exports.BadgeRectangle = (0, mobx_react_1.observer)(function (properties) {
    var _a, _b, _c;
    var globalTheme = (0, providers_1.useTheme)();
    var props = __assign(__assign(__assign({ 
        // default props
        color: 'rgba(58, 35, 173, 1)', colorText: '#fff' }, (_a = globalTheme === null || globalTheme === void 0 ? void 0 : globalTheme.components) === null || _a === void 0 ? void 0 : _a.badgeRectangle), properties), (_c = (_b = properties.theme) === null || _b === void 0 ? void 0 : _b.components) === null || _c === void 0 ? void 0 : _c.badgeRectangle);
    var value = props.value, disableStyles = props.disableStyles, tag = props.tag, className = props.className, style = props.style;
    var styling = {};
    if (!disableStyles) {
        styling.css = [CSS.BadgeRectangle(props), style];
    }
    else if (style) {
        styling.css = [style];
    }
    return value ? ((0, react_1.jsx)(providers_1.CacheProvider, null,
        (0, react_1.jsx)("div", __assign({}, styling, { className: (0, classnames_1.default)('ss__badge-rectangle', "ss__badge-rectangle--".concat(tag), className) }),
            (0, react_1.jsx)("span", { className: "ss__badge-rectangle__value" }, value)))) : ((0, react_1.jsx)(preact_1.Fragment, null));
});
